import { Yup } from "@pharmupp/p3-front-commons"
import { isValid } from "date-fns"
import {
  RPPSIdLength,
  isBirthDateRequired,
  isExternSpecRequired,
  isFunctionRequired,
  isPhoneRequired,
  isRPPSIdRequired,
  isTeamFunctionRequired,
  isTitleRequired,
} from "./GeneralInfos.rg"

const today = new Date()
const getMinDateMessage = (fieldLabel: string, minDate: Date) =>
  `${fieldLabel} doit être supérieure au ${minDate.toLocaleDateString("fr-FR")}`

export const generalInfosSchema = Yup.object({
  isUpdate: Yup.boolean().nullable(),
  lastName: Yup.string().required().max(30),
  firstName: Yup.string().required().max(30),
  birthName: Yup.string().nullable().max(30),
  phone: Yup.string()
    .nullable()
    .when("type", {
      is: isPhoneRequired,
      then: (schema) => schema.required(),
    }),
  email: Yup.string().email().max(75).required(),
  birthDate: Yup.string()
    .nullable()
    .when("type", {
      is: isBirthDateRequired,
      then: (schema) => schema.required(),
    }),
  title: Yup.string()
    .nullable()
    .when("type", {
      is: isTitleRequired,
      then: (schema) => schema.required(),
    }),
  type: Yup.string().required(),
  teamFunction: Yup.string()
    .nullable()
    .when("type", {
      is: isTeamFunctionRequired,
      then: (schema) => schema.required(),
    }),
  function: Yup.string()
    .max(50)
    .nullable()
    .when(["type", "teamFunction"], {
      is: isFunctionRequired,
      then: (schema) => schema.required(),
    }),
  externSpecification: Yup.string()
    .nullable()
    .when("type", {
      is: isExternSpecRequired,
      then: (schema) => schema.required(),
    }),
  programmedUnactivate: Yup.boolean().nullable(),
  unactivateDate: Yup.date()
    .nullable()
    .transform((currentValue) => (isValid(currentValue) ? currentValue : null))
    .when("programmedUnactivate", {
      is: true,
      then: (schema) =>
        schema
          .min(today, getMinDateMessage("La date de désactivation", today))
          .required("Veuillez saisir une date de désactivation"),
    }),
  rppsId: Yup.string()
    .trim()
    .transform((rppsId?: string) => (!rppsId ? null : rppsId))
    .nullable()
    .length(RPPSIdLength)
    .when(["type", "teamFunction"], {
      is: isRPPSIdRequired,
      then: (schema) => schema.required(),
    }),
})
